const { h, render, Component } = require('preact');
const ClaimTable = require('./claim_table')

class DetailTable extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    let claimDetails = this.props.claimDetails;
    return (
      <div class="order-details">
        <p class="merchant-name">{claimDetails.merchantName}</p>
        <ClaimTable claimDetails={claimDetails} />
      </div>
    );
  }
}
module.exports = DetailTable
